import React, { Fragment, Component } from "react";
import { connect } from "react-redux";
import { withRouter} from "react-router-dom";
import _ from 'lodash';
import queryString from 'query-string';
import {
  IconButton, Dialog, DialogTitle, DialogContent,
  Button,
  Fade,
  DialogActions,
  Grid,
} from "@material-ui/core";
import styled from "styled-components";
import CloseIcon from "@material-ui/icons/Close";
import ModalLoanItem from './ChangeDealStatusModal/ModalLoanItem';
import PrimaryButton from 'components/Global/Buttons/PrimaryButton';
import SecondaryButton from 'components/Global/Buttons/SecondaryButton';
import NoQuotes from './ChangeDealStatusModal/NoQuotes';
const Spacer = styled.div`
  flex-grow:1;
`
const SelectedItemsNotification = styled.div`
  && {
    font-size:17px;  
    padding-left:20px;
    margin:0;
  }
`
const Description = styled.div`
  color: rgba(0, 0, 0, 0.537);
  padding-bottom:20px;
`;

const Error = styled.div`
  color:#ff0000;
  font-size:17px;
  padding-left:8px;
`

const StyledDialogActions = styled(DialogActions)`
  && {
    justify-content: flex-end;
  }
  `

class CompareLoansModal extends Component {
  static DEFAULT_MAX_COUNT = 4;
  state = {
    activeStep: 0,
    shouldShowError:false,
    errorMessage: '',
    selectedLoanIds: []
  }
  close = () => {
    this.setState({
      selectedLoanIds: [],
      shouldShowError: false
    })
    this.props.onClose();
  }
  getSelectedCount = () => {
    return this.state.selectedLoanIds.length;
  }
  isMaxQuotesSelected = () => {
    return this.getSelectedCount() >= (this.props.maxCount || CompareLoansModal.DEFAULT_MAX_COUNT)
  }
  showMaxQuotesSelectedError = () => {
    this.setState({
      shouldShowError:true,
      errorMessage: `Only ${this.props.maxCount || CompareLoansModal.DEFAULT_MAX_COUNT} quotes can be compared`
    })
  }
  showNotEnoughQuotesSelectedError = () => {
    this.setState({
      shouldShowError:true,
      errorMessage: 'Must select at least two quotes'
    })
  }
  select = (selectedLoanIdsCopy, id) => {
    selectedLoanIdsCopy.push(id);
    this.setState({
      shouldShowError:false,
      selectedLoanIds:selectedLoanIdsCopy
    })
  }
  deselect = (selectedLoanIdsCopy, index) => {
    selectedLoanIdsCopy.splice(index,1);
    this.setState({
      shouldShowError:false,
      selectedLoanIds:selectedLoanIdsCopy
    })
  }
  onToggle = (id) => {
    const {selectedLoanIds} = this.state;    
    const selectedLoanIdsCopy = [...selectedLoanIds];
    let index = _.findIndex(selectedLoanIds, x => x === id );
    if(index === -1 && this.isMaxQuotesSelected())
      this.showMaxQuotesSelectedError();
    else if(index === -1)
      this.select(selectedLoanIdsCopy,id);
    else 
      this.deselect(selectedLoanIdsCopy,index);
   
  }
  isSelected = (selectedLoanIds,id) => {
    return _.findIndex(selectedLoanIds,  x=> x === id) !== -1;
  }

  goToCompare = () => {
    const{selectedLoanIds} = this.state; 
    if(selectedLoanIds.length === 0) return null;
    if(this.props.isModifying){
      this.goToCompareWithParent(selectedLoanIds[0]);
    } else {
      if(selectedLoanIds.length < 2){
        this.showNotEnoughQuotesSelectedError();
      }
      else {
       const {dealId} = this.props;
       let query = queryString.stringify(
         {
          loanId: selectedLoanIds,
          methodName: this.props.quoteType === "Supplemental" ? "supplementalCompare" : "compare",
          useAggregateExisting: this.props.quoteType === "Supplemental" ? true : !!this.state.useAggregateExisting,
        },
        {
          arrayFormat: 'bracket'
        });    
       this.props.history.push(`/pipeline/deal/${dealId}/quote-comparison?${query}`);
      }
    }
  }
  
  goToCompareWithParent = (loanId) => {
    let loan = null;
    this.props.loans.forEach(L => {
      if(L.id === loanId){
        loan = L;
      }
    });
    const {dealId} = this.props;
       let query = queryString.stringify(
         {
          loanId: [loanId, loan.unmodifiedLoanId],
          methodName: "compare",
          useAggregateExisting: false
        },
        {
          arrayFormat: 'bracket'
        });    
       this.props.history.push(`/pipeline/deal/${dealId}/quote-comparison?${query}`);
  }

  renderLoans = () => {    
    const {selectedLoanIds} = this.state;            
    return this.props.loans.map( x=> {
      if(!x.title) x.title = x["loanProvider.name"];
      return(
      <ModalLoanItem 
        key={x.id}
        toggle={this.onToggle} 
        loan={x} 
        isSelected={this.isSelected(selectedLoanIds, x.id)}/>
      )}
    );
  }
  
  render() {
    
    const { shouldShowError,errorMessage} = this.state;
    const { isOpen, maxCount, quoteType, loans } = this.props;    
    
    return (
      <Fragment>
        <Dialog open={isOpen} onClose={this.close} fullWidth maxWidth="md">
          <Grid
            container
            direction="row"
            alignItems="center"
            justify="space-between"
          >
            <DialogTitle>Compare {quoteType} {this.props.isModifying ? "Loans" : "Quotes"}</DialogTitle>
            <IconButton style={{ marginRight: 16 }} onClick={this.close}>
              <CloseIcon style={{ fontSize: 36 }} />
            </IconButton>
          </Grid>          
          <DialogContent>
            <Description>{this.props.isModifying ? `Select a modified loan to compare to its previous, active version:` : `Select up to four (4) quotes to compare:`}</Description>            
            {_.isEmpty(this.props.loans) && <NoQuotes/>}
            <Grid container direction="row" spacing={8}>
              {this.renderLoans()}
            </Grid>
          </DialogContent>
          <StyledDialogActions>
            <SelectedItemsNotification>{this.getSelectedCount(loans)}/{maxCount || CompareLoansModal.DEFAULT_MAX_COUNT} Selected</SelectedItemsNotification>
            <Fade in={shouldShowError}>
              <Error>{errorMessage}</Error>
            </Fade>
            <Spacer></Spacer>
            <Fragment>
              <SecondaryButton onClick={this.close}>Cancel</SecondaryButton>
              <PrimaryButton disabled={_.isEmpty(this.props.loans)} onClick={this.goToCompare}>Go To Compare</PrimaryButton>
            </Fragment>
          </StyledDialogActions>
        </Dialog>
      </Fragment>
    )
  }
}


export default withRouter(CompareLoansModal);
